
























































































































































































import BillingPrice from '@/datatypes/billing/price';
import User from '@/datatypes/user';
import BillingPriceService from '@/services/billing/BillingPriceService';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import MoneyInput from '@/components/money.vue';
import BillingPriceMetadata from '@/components/billing/Metadata.vue';
import BillingPriceUpdateRequest from '@/datatypes/billing/price-update-request';

export default Vue.extend({
  data: () => ({
    billingPrice: new BillingPrice({}),
    billingPriceService: new BillingPriceService(),
    billingSchemes: {
      perUnit: 'Unit',
      tiered: 'Tier (unsupported)',
    },
    isUpdatingPrice: false,
    user: new User({}),
  }),

  components: {
    MoneyInput,
    BillingPriceMetadata,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  computed: {
    updateable(): boolean {
      if (!this.billingPrice.billingProduct.editable) return false;

      if (
        (this.billingPrice.recurring.usageType === 'licensed')
        && this.billingPrice.metadata.complete()
        && this.billingPrice.metadata.quota
        && this.billingPrice.metadata.overageUnitAmount
      ) {
        return true;
      }

      return (
        (this.billingPrice.recurring.usageType === 'metered')
        && this.billingPrice.metadata.completePayg()
      );
    },
  },

  methods: {
    routeChanged() {
      this.getBillingPrice();
    },

    userKindName(value): string {
      const name = this.user.kindHash.find((item) => item.kind === parseInt(value, 10))?.name;

      if (!name) {
        return '';
      }

      return name;
    },

    updatePrice() {
      const request = new BillingPriceUpdateRequest(this.billingPrice);

      this.billingPriceService.update(this.billingPrice.id, request).then((response) => {
        this.$snackbar.message('Price updated.');
        this.billingPrice = new BillingPrice(camelcaseKeysDeep(response.data));
        this.isUpdatingPrice = false;
        this.$router.push(`/billing-prices/${this.billingPrice.id}`);
      });
    },

    getBillingPrice() {
      const billingPriceId = this.$route.params.id;

      this.billingPriceService.show(billingPriceId).then((response) => {
        this.billingPrice = new BillingPrice(camelcaseKeysDeep(response.data));
      });
    },
  },
});
